/*** IMPORTS FROM imports-loader ***/
var define = false;

import tagTester from './_tagTester.js';

export default tagTester('Date');




//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/isDate.js
// module id = 155
// module chunks = 0